<template>
  <div>
    <div class="max-w-5xl mx-auto">
      <div class="space-y-8">
        <BaseButton type="button" info class="ml-1" :disabled="exporting" @click="handleExport">
          <Loader v-if="exporting" inverse small />
          <span v-else>Export</span>
        </BaseButton>
        <VList>
          <template #before>
            <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
              <div class="w-32 px-4">Date</div>
              <div class="flex-1 px-4">Document</div>
              <div class="w-32 px-4 text-right">Amount</div>
              <div class="w-32 px-4 text-right">Balance</div>
            </div>
          </template>

          <template v-if="movements.length" #default>
            <template v-for="movement in movementsWithRunningBalance">
              <VListLine :key="`account_client_movement_${movement.uuid}`" :movement="movement" />
            </template>
          </template>

          <template v-else #default>
            <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
              No results found
            </div>
          </template>
        </VList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import VList from '@/components/Common/VList.vue';
import VListLine from '@/components/AccountRelationMovements/VListLine.vue';
import { clientAgencyMovementsClient } from '@/api/clients';

export default {
  components: {
    VList,
    VListLine,
  },

  props: {
    agencyUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      exporting: false,
    };
  },

  async beforeRouteEnter(to, from, next) {
    const { agencyUuid: clientAgencyUuid } = to.params;

    try {
      await store.dispatch('ui/clientAgencyMovements/load', { clientAgencyUuid });
      next();
    } catch (error) {
      next(false);
    }
  },

  computed: {
    ...mapGetters('ui/clientAgencies', ['clientAgency']),
    ...mapGetters('ui/clientAgencyMovements', ['movements']),
    movementsWithRunningBalance() {
      const { balance = 0 } = this.clientAgency || {};
      let runningBalance = balance;
      return this.movements.reduce((acc, cur) => {
        const newCur = { ...cur, balance: runningBalance };
        runningBalance -= newCur.amount;
        return [...acc, newCur];
      }, []);
    },
  },
  methods: {
    async handleExport() {
      this.exporting = true;

      try {
        const response = await clientAgencyMovementsClient.export(this.agencyUuid, {
          responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'movements.xlsx');
        link.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        /** handle error */
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
